<template>
  <div>
  <v-app-bar
    app
    flat
    :clipped-left="isClippedLeft"
    :clipped-right="isClippedRight"
    v-if="isVisibleHeader && !isRolDisplayUser()"
    v-bind="bindStyle"
    :dense="isDense"
    :prominent="isProminent"
    :hide-on-scroll="isHideOnScroll"
    :shrink-on-scroll="isShrinkOnScroll"
  >
    <v-sheet
      color="transparent"
      v-if="isClippedOver || $vuetify.breakpoint.mdAndDown"
    >
      <v-list-item class="pl-0">
        <v-list-item-avatar tile height="40" width="30">
          <img :src="require('@/assets/fs/symbol-logo_fs_sinfondo.png')" alt="Futurespace logo" />
        </v-list-item-avatar>
        <v-list-item-content v-if="$vuetify.breakpoint.mdAndUp">
          <v-list-item-title class="text-h6 primary--text"
            >{{ $t('Global.Main.appName') }}</v-list-item-title
          >
        </v-list-item-content>
        <v-list-item-action v-if="$vuetify.breakpoint.lgAndUp">
          <v-btn
            @click.stop="toggleMiniVariant"
            small
            fab
            :class="!bindStyle.color ? 'neu-glow' : ''"
          >
            <v-icon
              :color="!bindStyle.color ? 'primary' : bindStyle.color"
              v-if="isMinSideNav"
              >double_arrow</v-icon
            >
            <v-icon
              :color="!bindStyle.color ? 'primary' : bindStyle.color"
              v-else
              >menu_open</v-icon
            >
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-sheet>
    <div v-if="$vuetify.breakpoint.lgAndUp">
      <!-- toggle Mini variant -->
      <v-btn
        @click.stop="toggleMiniVariant"
        small
        fab
        :class="!bindStyle.color ? 'neu-glow' : ''"
        v-if="!isClippedOver"
      >
        <v-icon
          :color="!bindStyle.color ? 'primary' : bindStyle.color"
          v-if="isMinSideNav"
          >double_arrow</v-icon
        >
        <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color" v-else
          >menu_open</v-icon
        >
      </v-btn>
    </div>
    <v-spacer />
    <v-btn
      v-if="$vuetify.breakpoint.mdAndDown"
      class="mr-3"
      small
      fab
      :class="!bindStyle.color ? 'neu-glow' : ''"
      @click="handleSidenavDrawer()"
    >
      <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color"
        >menu</v-icon
      >
    </v-btn>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            @click="handleKiosk(false)"
            small
            fab
            class="neu-glow mr-3"
            v-bind="attrs"
            v-on="on"
        >
          <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color">
            mdi-monitor-eye
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Global.Main.fullScreen') }}</span>
    </v-tooltip>
    <!-- Language Menu -->
<!--    <v-menu offset-y close-on-click>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small fab class="neu-glow mr-3">
          <v-avatar size="30">
            <v-img :src="currentLocaleImg"></v-img>
          </v-avatar>
        </v-btn>
      </template>

      <v-list dense class="neu-glow">
        <v-list-item
          v-for="(item, index) in langs"
          :key="index"
          @click="handleInternationalization(item.value)"
        >
          <v-list-item-avatar tile class="with-radius" size="25">
            <v-img :src="item.img"></v-img>
          </v-list-item-avatar>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>-->
    <!-- User Profile Menu -->
    <v-menu offset-y min-width="160"  v-if="!isRolDisplayUser()">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small fab class="neu-glow mr-3">
          <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color">
            mdi-account
          </v-icon>
        </v-btn>
      </template>
      <v-list nav class="neu-glow-primary with-radius">
        <template v-for="(item, index) in items">
          <v-divider v-if="item.divider" :key="index"></v-divider>
          <v-list-item v-else :key="index" @click="item.action" class="ma-0" >
            <v-list-item-icon class="pl-2 mr-5">
              <v-icon class="pa-0" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ma-0 pa-0">
              <v-list-item-title><p class="ma-0 pa-0">{{ item.text }}</p></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
    <!-- User Info -->
    <v-sheet class="mx-7" color="transparent"  v-if="$vuetify.breakpoint.smAndUp">
      <v-row class="truncate-text">
        <p class="ma-0 pa-0">
          <span>{{ $t('Global.Main.welcome') }} </span>
          <span class="font-weight-bold">{{ getUserLogin || '' }} </span>
        </p>
      </v-row>
      <v-row>
        <p class="ma-0 pa-0">
          <span>{{ $t('Global.Main.lastLogin') }} </span>
          <span class="font-weight-bold">{{ formatPreviousAccessDateTime || '' }} </span>
        </p>
      </v-row>
    </v-sheet>
  </v-app-bar>

    <v-tooltip :nudge-left="120" v-else-if="!isRolDisplayUser()">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            @click="handleKiosk(true)"
            small
            fab
            class="neu-glow mr-3"
            id="floating-kiosk"
            v-bind="attrs"
            v-on="on"
        >
          <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color">
            mdi-monitor-off
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Global.Main.closefullScreen') }}</span>
    </v-tooltip>

    <!-- User Profile Menu USER DISPLAY -->
    <v-menu offset-y min-width="160" v-if="isRolDisplayUser()">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small fab class="neu-glow mr-3" id="user-profile-display">
          <v-icon :color="!bindStyle.color ? 'primary' : bindStyle.color">
            mdi-account
          </v-icon>
        </v-btn>
      </template>
      <v-list nav class="neu-glow-primary with-radius">
        <template v-for="(item, index) in items">
          <v-divider v-if="item.divider" :key="index"></v-divider>
          <v-list-item v-else :key="index" @click="item.action" class="ma-0" >
            <v-list-item-icon class="pl-2 mr-5">
              <v-icon class="pa-0" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ma-0 pa-0">
              <v-list-item-title><p class="ma-0 pa-0">{{ item.text }}</p></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <confirm-dialog
      ref="confirmDialog"
      :title="confirmDialogTitle"
      :message="confirmDialogMessage"
    />
    <profile-card
      v-if="profileView"
      :activate="profileView"
      @close-profile="profileView=false"
    />
    
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {availableLocale} from "@/config/locale";
import moment from "moment";
import AuthApi from "@/mixins/Services/AuthApi";
import logoutSession from "@/mixins/Logout";
import ConfirmDialog from "@/components/UI/Dialogs/ConfirmDialog";
import ProfileCard from "./ProfileCard.vue";
import ROL from "@/config/rol-values";

export default {
  name: "Toolbar",
  components: {
    ConfirmDialog,
    ProfileCard
  },
  props: {
    handleSettingsDrawer: Function,
  },
  mixins: [AuthApi, logoutSession],
  data() {
    return {
      authUser: {
        name: "Alice Blue",
        firstname: "Alice",
        lastname: "Blue",
        email: "aliceblue@example.com",
        avatar: `/static/ali.jpg`,
        mood: "Vuse - Powerful VuejS admin template.",
        status: {
          color: "success",
          icon: "check_circle",
        }
      },
      items: [
        { icon: "person", text: this.$t("Global.Main.profileMenu"), action: () => { this.profileView=true } },
        // { icon: "settings", text: this.$t("Global.Main.settingsMenu"), action: () => {}  },
        { icon: "mdi-theme-light-dark", text: this.$t("Global.Main.themeMenu"), action: () => this.handleTheme() },
        { divider: true },
        { icon: "power_settings_new", text: this.$t("Global.Main.logoutMenu"), action: () => this.handleLogout() },
      ],
      langs: availableLocale,
      confirmDialogTitle: "",
      confirmDialogMessage: null,
      profileView: false,
      rol: ROL
    };
  },
  computed: {
    activeItemStyle: (state) => state.activeMenuStyle,
    ...mapGetters("navigations", [
      "isVisibleHeader",
      "isSidenavPostionRight",
      "isClippedOver",
      "isMinSideNav",
      "isDense",
      "isProminent",
      "isHideOnScroll",
      "isShrinkOnScroll",
      "isFloating",
    ]),
    ...mapGetters("scheme", ["header"]),
    ...mapGetters(["locale"]),
    ...mapGetters(["getUserLogin", "getPreviousAccessDateTime", "getSessionTime", "getCompanyPath", "getRoleId"]),
    formatPreviousAccessDateTime() {
      return this.getPreviousAccessDateTime ? moment(this.getPreviousAccessDateTime).format('YYYY-MM-DD HH:mm') : 'no time'
    },
    isClippedRight() {
      return this.isClippedOver && this.isSidenavPostionRight;
    },
    isClippedLeft() {
      return this.isClippedOver && !this.isSidenavPostionRight;
    },
    bindStyle() {
      const { color, dark, classes } = this.header;
      return {
        class: {
          "vuse-header": true,
          "with-radius": true,
          [classes]: true,
          "mx-6 mt-3": this.isFloating && !this.isClippedOver,
        },
        dark,
        color,
      };
    },
    currentLocaleImg() {
      return this.langs.find((item) => item.value === this.locale).img;
    },
  },
  methods: {
    ...mapActions(["deleteDefsData", "setLogout"]),
    ...mapActions("navigations", ["setSidenavVisibility", "setHeaderVisibility" ]),
    handleKiosk(action) {
      this.setSidenavVisibility(action)
      this.setHeaderVisibility(action)
    },
    toggleMiniVariant() {
      this.$store.dispatch("navigations/setMiniVariant");
    },
    handleSidenavDrawer() {
      this.$store.dispatch("navigations/setSidenavVisibility");
    },
    handleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    },
    handleInternationalization(value) {
      this.$store.dispatch("setLocale", value)
    },
    async handleLogout() {
      this.confirmDialogTitle = this.$t("Global.ConfirmDialog.logoutTitle")
      this.confirmDialogMessage = this.$t("Global.ConfirmDialog.logoutMessage")
      const response = await this.$refs.confirmDialog.open()
      if (response) this.logoutSession(this.getCompanyPath)
    },
    isRolDisplayUser(){
      return [this.rol.DISPLAY_USER].includes(this.getRoleId)
    }
  }
};
</script>
<style>
  #floating-kiosk {
    position: fixed;
    top: 30px;
    right: 1%;
    z-index: 999;
  }
  #user-profile-display {
    position: fixed;
    top: 30px;
    right: 1%;
    z-index: 999;
  }
</style>
